export type WarningType = "info" | "warning" | "error";

export interface Warning {
  id: string;
  message: string | React.ReactNode;
  type: WarningType;
  // autoClose: boolean;
  // duration: number;
  timer?: NodeJS.Timeout;
  ressourceId?: number;
}

interface WarningState {
  warnings: Warning[];
  addWarning: (
    message: string | React.ReactNode,
    type?: WarningType,
    // autoClose?: boolean,
    ressourceId?: number
  ) => void;
  removeWarning: (id: string) => void;
  clearWarnings: () => void;
  removeWarningByRessourceId: (ressourceId: number) => void;
}

import { create } from "zustand";
import { devtools } from "zustand/middleware";

export const useWarningStore = create<WarningState>()(
  devtools((set, get) => ({
    warnings: [],

    addWarning: (message, type: WarningType = "info", ressourceId?: number) => {
      const id = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      const warn: Warning = { id, message, type, ressourceId };

      // console.log("warn >>>>>>>>>>>>>>>>>>>>>>>>>>>>>> ||||||||||| ", warn);

      // if (autoClose) {
      //   warn.timer = setTimeout(() => {
      //     get().removeWarning(id);
      //   }, duration);
      // }

      set((state) => ({ warnings: [...state.warnings, warn] }));
    },

    removeWarning: (id) => {
      set((state) => {
        const warn = state.warnings.find((w) => w.id === id);
        if (warn?.timer) clearTimeout(warn.timer);
        return { warnings: state.warnings.filter((w) => w.id !== id) };
      });
    },

    removeWarningByRessourceId: (ressourceId: number) => {
      set((state) => ({ warnings: state.warnings.filter((w) => w.ressourceId !== ressourceId) }));
    },

    clearWarnings: () => {
      get().warnings.forEach((w) => w.timer && clearTimeout(w.timer));
      set({ warnings: [] });
    },
  }))
);
